import { selectors } from '@bt-react/store'
import isEmpty from 'lodash/isEmpty'

/** This selector checks to make sure all requirements are met to access the presenter room */

export default function (state) {

  const { username, roomname, role } = state.config
  const { uiDoc, bookingDoc } = state.docs
  const { status, isTerminated } = state.ui
  const { room } = state.room
  const webcast = selectors.selectWebcast(state)

  if (
    username &&
    roomname &&
    role &&
    uiDoc &&
    bookingDoc &&
    status &&
    !isTerminated &&
    !isEmpty(webcast)
  ) return true

  return false

}
